export default [
  {
    login: 'Loremiak',
    id: 99645860,
    node_id: 'U_kgDOBfB5pA',
    avatar_url: 'https://avatars.githubusercontent.com/u/99645860?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/Loremiak',
    html_url: 'https://github.com/Loremiak',
    followers_url: 'https://api.github.com/users/Loremiak/followers',
    following_url:
      'https://api.github.com/users/Loremiak/following{/other_user}',
    gists_url: 'https://api.github.com/users/Loremiak/gists{/gist_id}',
    starred_url: 'https://api.github.com/users/Loremiak/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/Loremiak/subscriptions',
    organizations_url: 'https://api.github.com/users/Loremiak/orgs',
    repos_url: 'https://api.github.com/users/Loremiak/repos',
    events_url: 'https://api.github.com/users/Loremiak/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/Loremiak/received_events',
    type: 'User',
    site_admin: false,
  },
];
